import type { DuplicateRequestResponse } from "@nlc/shared-types";
import type { DefaultValues, UseFormReset } from "react-hook-form";

import { BriefCreatorTypeEnum } from "@nlc/shared-types";

import type { CreateGraphicRequestFormData } from "../components/useCreateGraphicRequestForm";

import {
  mapAttachmentsByCategory,
  useDuplicateRequest,
} from "../../shared/useDuplicateRequest";

function mapDuplicateResponseToFormData(
  data: DuplicateRequestResponse,
): DefaultValues<CreateGraphicRequestFormData> {
  const briefCreatorType = data.briefText
    ? BriefCreatorTypeEnum.DETAILED
    : BriefCreatorTypeEnum.SINGLE;

  return {
    assets: mapAttachmentsByCategory(data.attachments, "asset"),
    brand: data.brandId || undefined,
    briefCreatorDetailed: {
      additionalGuidelines:
        data.magicalBriefCreator?.additionalGuidelines || "",
      brandGuidelines: data.magicalBriefCreator?.brandGuidelines || "",
      creativeGoal: data.magicalBriefCreator?.creativeGoals || "",
      finalBrief: data.briefText || "",
      finalBriefHTML: data.briefText || "",
      keyMessageAndCta: data.magicalBriefCreator?.keyMessageAndCta || "",
      scope: data.magicalBriefCreator?.scope || "",
    },
    briefCreatorSingle: {
      requestDescription: data.description || "",
      requestDescriptionHTML: data.description || "",
      textsForDesign: data.textForDesign || "",
      textsForDesignHTML: data.textForDesign || "",
    },
    briefCreatorType,
    collaboratorIds: data.collaboratorIds || [],
    creativeDirection: data.creativeDirection || undefined,
    designComplexity: data.complexityId || undefined,
    designType: data.designTypeId ?? undefined,
    fileTypes: data.preferredFileType || "",
    inspirations: mapAttachmentsByCategory(data.attachments, "example"),
    preferredDesignerIds: data.preferredDesignerIds || [],
    requestName: data.name || "",
    sizes: data.sizesNeeded || "",
  };
}

interface UseDuplicateGraphicRequestProps {
  reset: UseFormReset<CreateGraphicRequestFormData>;
}

export function useDuplicateGraphicRequest({
  reset,
}: UseDuplicateGraphicRequestProps) {
  return useDuplicateRequest<CreateGraphicRequestFormData>({
    mapDuplicateResponseToFormData,
    reset,
  });
}
